import { defineAsyncComponent, type Component } from "vue";

export const PORTFOLIO_SETTINGS_SIDEBARS = {
  TASKS_PER_ROLE: {
    sidebar: "portfolio-settings-tasks-per-role",
  },
  TAGS: {
    sidebar: "portfolio-settings-tags",
  },
  SKILLS: {
    sidebar: "portfolio-settings-skills",
  },
  CATEGORIES: {
    sidebar: "portfolio-settings-categories",
  },
  REFERENCES: {
    sidebar: "portfolio-settings-references",
  },
  COMPETENCES: {
    sidebar: "portfolio-settings-competences",
  },
  ATTACHMENTS: {
    sidebar: "portfolio-settings-attachments",
  },
  HOUR_REGISTRATION: {
    sidebar: "portfolio-settings-hour-registration",
  },
} as const;

export type PortfolioSettingsSidebarEntry =
  (typeof PORTFOLIO_SETTINGS_SIDEBARS)[keyof typeof PORTFOLIO_SETTINGS_SIDEBARS];
export type PortfolioSettingsSidebarValue =
  PortfolioSettingsSidebarEntry["sidebar"];

interface SidebarConfig {
  component: Component;
}

export const PORTFOLIO_SETTINGS_SIDEBAR_COMPONENTS: Record<
  PortfolioSettingsSidebarValue,
  SidebarConfig
> = {
  [PORTFOLIO_SETTINGS_SIDEBARS.TASKS_PER_ROLE.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("portfolio/components/settings/PortfolioTasksPerRoleDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.TAGS.sidebar]: {
    component: defineAsyncComponent(
      () => import("portfolio/components/settings/PortfolioTagsDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.SKILLS.sidebar]: {
    component: defineAsyncComponent(
      () => import("portfolio/components/settings/PortfolioSkillsDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.CATEGORIES.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("portfolio/components/settings/PortfolioCategoriesDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.REFERENCES.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("portfolio/components/settings/PortfolioReferencesDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.COMPETENCES.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("portfolio/components/settings/PortfolioCompetencesDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.ATTACHMENTS.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("portfolio/components/settings/PortfolioAttachmentsDrawer.vue"),
    ),
  },
  [PORTFOLIO_SETTINGS_SIDEBARS.HOUR_REGISTRATION.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import(
          "portfolio/components/settings/PortfolioHourRegistrationDrawer.vue"
        ),
    ),
  },
};
